import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import { fontList } from 'constants'

const FontFamilySelector = ({ onClick, value }) => {
  const handleChange = (e) => onClick(e.target.value)

  return (
    <Stack direction={'row'}>
      <FormControl>
        <Select
          value={value}
          displayEmpty
          onChange={handleChange}
          sx={{ width: 200 }}
        >
          {fontList.map((font) => (
            <MenuItem value={font} key={font}>
              <Typography fontFamily={font}>{font}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  )
}

export default FontFamilySelector
